import Vue from 'vue';
import store from '@/store';

import VueApexCharts from 'vue-apexcharts';
import TitleTip from '@/components/TitleTip';
import Amount from '@/components/Amount';
import FileUpload from '@/components/FileUpload';
import TabsBar from '@/components/TabsBar';
import RsStep from '@/components/Steps';
import NoData from '@/components/NoData';
import TextMore from '@/components/TextMore';
import {Button, MessageBox, Message, Loading} from 'element-ui';

import {resetAuthenticationStatus} from '@/api/user';

// page title
Vue.use(VueApexCharts);

Vue.component('RsStep', RsStep);
Vue.component('TitleTip', TitleTip);
Vue.component('Amount', Amount);
Vue.component('FileUpload', FileUpload);
Vue.component('TabsBar', TabsBar);
Vue.component('ApexChart', VueApexCharts);
Vue.component('NoData', NoData);
Vue.component('TextMore', TextMore);

/**
 * 法大大确认弹框
 * @param {*} title 显示标题
 * @param {*} message 显示内容
 * @param {*} status 操作状态
 * @param {*} url 法大大网页地址
 * @returns
 */
Vue.prototype.$fadadaConfirm = function (title, message, status, url) {
    const h = this.$createElement;
    if (!url) return;
    // 限制法大大小程序只能在小程序认证，PC只能在PC认证
    if (/wx:\/\//.test(url)) return this.$message.warning('请在小程序中进行实名认证');
    return new Promise((resolve) => {
        if (status === 0) return resolve('');
        const createButton = (text, classes = '', onClick) => {
            return h(Button, {class: classes, on: {click: onClick}}, text);
        };
        const text = title.slice(-2);
        const btns = [
            createButton(`取消`, '', () => {
                MessageBox.close();
            }),
            createButton(`完成${text}`, 'el-button--base', () => {
                MessageBox.close();
                resolve(status === 2 ? 'success' : 'refresh');
            }),
        ];
        // 继续认证
        if (url) {
            btns.splice(
                1,
                0,
                createButton(`继续${text}`, 'el-button-primary', () => {
                    window.open(url, '_blank');
                })
            );
        }

        MessageBox({
            title,
            message: h('div', null, [h('p', null, message), h('div', {style: 'text-align: right; margin-top: 20px;'}, btns)]),
            dangerouslyUseHTMLString: true,
            closeOnClickModal: false,
            showConfirmButton: false,
            showClose: false,
            showCancelButton: false,
            closeOnPressEscape: false,
        });
    });
};

/**
 * 签约平台正确路由
 * @param {string} path 被替换的URL地址
 * @param {string} type 是直接跳转还是返回修改后的url
 * @return {string}
 */
Vue.prototype.$contractRouter = function (path, type = 'router') {
    const {verificationPlatform} = store.state;
    if (verificationPlatform == 1) return type === 'router' ? this.$router.push(path.replace(/fdd/g, 'dzq')) : path.replace(/fdd/g, 'dzq');
    return type === 'router' ? this.$router.push(path) : path;
};

/**
 * 电子签平台迁移法大大
 * @param {string} step 进入认证第几步
 */
Vue.prototype.$dzqToFdd = function (reVerifyType, step = 1) {
    const {verificationPlatform} = store.state;
    if (verificationPlatform == 1) {
        MessageBox.confirm('您需要重新认证后签约', '重新认证', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(async () => {
                // // 重置认证数据
                // let loadingInstance = Loading.service({fullscreen: true, text: '正在重置用户认证状态，请稍后...'});
                // const response = await resetAuthenticationStatus();
                // const {state, msg} = response.data;
                // loadingInstance.close();
                // if (!state) return Message.error(msg || '重置用户认证状态失败');
                let loadingInstance = Loading.service({fullscreen: true, text: '正在请求中，请稍后...'});
                // 更新用户信息
                await store.dispatch('getUserInfo');
                // 完成跳转
                //签署合同
                if(reVerifyType) {
                    this.$router.push(`/manage/contract/verify/fdd/step/${step}?reVerifyType=${reVerifyType}`);
                }else {
                    this.$router.push(`/manage/contract/verify/fdd/step/${step}`);
                }
                loadingInstance.close();
            })
            .catch(() => {
                this.$router.go(-1);
            });
        return false;
    }
    return true;
};

/**
 * 电子签平台迁移法大大
 * @param {string} step 进入认证第几步
 */
Vue.prototype.$dzqToFddNew = function (reVerifyType, data, step = 1) {
    const {verificationPlatform} = store.state;
    if (verificationPlatform == 1) {
        MessageBox.confirm('您需要重新认证', '重新认证', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(async () => {
                let loadingInstance = Loading.service({fullscreen: true, text: '正在请求中，请稍后...'});
                // 更新用户信息
                await store.dispatch('getUserInfo');
                // 完成跳转
                //手机号
                if(reVerifyType == 1) {
                    this.$router.push(`/manage/contract/verify/fdd/step/${step}?type=dzq&reVerifyType=1&telephone=${btoa(data)}`);
                }else if(reVerifyType == 2){
                    this.$router.push(`/manage/contract/verify/fdd/step/${step}?type=dzq&reVerifyType=2&name=${encodeURIComponent(data)}`);
                } else {
                    this.$router.push(`/manage/contract/verify/fdd/step/${step}?type=dzq`);
                }
                loadingInstance.close();
            })
            .catch(() => {
                this.$router.go(-1);
            });
        return false;
    }
    return true;
};